import { gql } from '@apollo/client';

const PartnerUserInfo = gql`
  fragment PartnerUserInfo on PartnerUser {
    id
    firstName
    lastName
    email
    emailDeliverabilityStatus
    phone
    language
    roleTypeId
    state
    partnerLocation {
      id
      name
    }
    partnerLocationId
    partnerOrganizationId
    partnerOrganization {
      id
      name
    }
    roleType {
      id
      name
    }
    imageUrl
    lastLoginAt
    createdAt
    updatedAt
  }
`;

export default PartnerUserInfo;
